import cashDeskInstance from './instance'

const updateClientMonitorConfig = (data) => {
	return cashDeskInstance.put('/clientMonitorConfig', data)
}

export default updateClientMonitorConfig
